<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<el-table
				class="table-responsive table-flush sf-datatable el-table--scrollable-y"
				ref="dataTable"
				:data="groups"
				border
				highlight-current-row
				@row-click="selectRow"
				height="100%"
			>
				<el-table-column :label="getMessage_('SWCC000420')" type="index" width="115"> </el-table-column>
				<!-- 번호 -->
				<el-table-column :label="getMessage_('SWCC000150')" property="permGrpCd" width="100"> </el-table-column>
				<el-table-column :label="getMessage_('SWCC000426')" property="userGrpName" width="300"> </el-table-column>
				<!-- 그룹명 -->
			</el-table>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
export default {
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		getData() {
			this.$sf_toggleLoading(true);
			this.getGroups_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		selectRow(row) {
			this.setSearchParam_({ key: 'groupId', value: row.permGrpCd });
			this.$emit('SelectMenu');
		}
	}
};
</script>

<style></style>
